import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09f779bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "payment-head" }
const _hoisted_3 = { class: "payment-text" }
const _hoisted_4 = { class: "bold" }
const _hoisted_5 = { class: "date-paid" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "payment-text" }, "Ordren er fakturert", -1))
const _hoisted_8 = { class: "date-paid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_CollapseTransition = _resolveComponent("CollapseTransition")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_CollapseTransition, null, {
      default: _withCtx(() => [
        (_ctx.invoice)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["message", _ctx.messageClass])
            }, [
              (_ctx.isPayed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_SvgIcon, {
                        class: "payment-icon",
                        type: "mdi",
                        path: _ctx.checkIcon
                      }, null, 8, ["path"]),
                      _createElementVNode("p", _hoisted_3, [
                        _createTextVNode(" Ordren er betalt "),
                        _createElementVNode("span", _hoisted_4, "(" + _toDisplayString(_ctx.invoice.payment_type) + ")", 1)
                      ])
                    ]),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.date_paid), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.date_invoiced), 1)
                  ]))
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}